import c from 'classnames';

import { Button, LoadingLines, SpinnerCircular } from '@repo/ui';

import type { UseTinyAIChatReturn } from '../../../hooks/useTinyAIChatTRPC';
import type { useTinyAIScrollOrchestrator } from '../hooks/useTinyAIScrollOrchestrator';
import { AIMessage, LoadingLabel, UserMessage } from '../Messages';

import styles from './TinyAIMessageList.module.css';

interface TinyAIMessageListProps {
  chat: UseTinyAIChatReturn & { isAnswering: boolean };
  scroll: ReturnType<typeof useTinyAIScrollOrchestrator>;
}

export const TinyAIMessageList = ({
  chat,
  scroll,
}: TinyAIMessageListProps) => {
  return (
    <div
      className={styles.messagesContainer}
      ref={scroll.messagesContainerRef}
    >
      {chat.isLoadingMoreHistory && (
        <div className={styles.loadingMore}>
          <SpinnerCircular
            size={24}
            color='var(--purple-300)'
            secondaryColor='transparent'
          />
        </div>
      )}
      {chat.messages.map(message => (
        <div
          key={message.id}
          data-message-id={message.id}
          className={styles.messageWrapper}
        >
          {message.senderType === 'user' ? (
            <UserMessage message={message.messageText} />
          ) : (
            <AIMessage
              message={message.messageText}
              messageId={message.id}
              isStreaming={message.id === chat.streamingMessageId}
              hasFeedback={message.hasFeedback === true}
              metadataJson={message.metadataJson}
              onRetry={chat.retryLastMessage}
            />
          )}
        </div>
      ))}
      {chat.isLoading && (
        <div className={styles.messageWrapper}>
          <LoadingLabel />
          <LoadingLines lines={3} />
          <Button
            variant='text'
            size='small'
            color='purple'
            iconNameLeft='closeSm'
            label='Cancel'
            onClick={chat.cancelLoading}
            className={c(styles.cancelButton, 'mt-2')}
          />
        </div>
      )}
      <div ref={scroll.messagesEndRef} />
      {chat.isAnswering && (
        <div
          data-bottom-spacer
          className={styles.bottomSpacer}
          aria-hidden='true'
        />
      )}
    </div>
  );
};
